import { HEDGE_TYPES, HEDGE_STATUSES } from "@loanbossinc/component-library";
import { isContainedInList } from "helpers/row-logic-helper";

export const shouldShowPaymentDay = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowPaymentDayAdjust = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowCalculationDay = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowCalculationDayAdjust = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowRounding = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowResetDay = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowResetDayAdjust = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowResetDayLookback = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowLei = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowCollateral = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.SWAP,
    HEDGE_TYPES.COLLAR
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowGuaranty = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.SWAP,
    HEDGE_TYPES.COLLAR
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowCollateralAssignment = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.CAP,
    HEDGE_TYPES.FLOOR
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowLegalOpinion = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.CAP,
    HEDGE_TYPES.FLOOR
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowLoanTag = hedge => {
  if (hedge.taggedTo != null) {
    return !hedge.taggedTo;
  }

  return Boolean(hedge.loanId && !hedge.loanId === "--");
};
